import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import FieldOptionUserModel from "../../models/field-option-user";

export default class FieldOptionUserRepository extends BaseRepository {
  static modelClass = FieldOptionUserModel;
  modelName = "field-option-user";
}
